import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import Quasar from 'quasar/src/vue-plugin.js';
import quasarUserOptions from './quasar-user-options'
import { createPinia } from 'pinia'
import i18n from "@/i18n";

createApp(App)
    .use(i18n)
    .use(Quasar, quasarUserOptions)
    .use(createPinia())    // подключение Pinia вместо Vuex
    .use(router)
    .mount('#app')
